declare var window: any;
import { ClassTransformOptions, Type, plainToClass } from 'class-transformer';
import Model from './Model';
import Feedback from './Feedback';
import FeedbackQuestion from './FeedbackQuestion';

class FeedbackResponse extends Model {

    id: number;
    value: string;

    @Type(() => Feedback)
    feedback: Feedback;

    @Type(() => FeedbackQuestion)
    feedback_question: FeedbackQuestion;

    @Type(() => Date)
    created_at: Date;
    @Type(() => Date)
    updated_at: Date;


    /*
    |--------------------------------------------------------------------------
    | Reflection
    |--------------------------------------------------------------------------
    */

    /**
     * Gets class name
     * survives minification/uglification
     *
     * @return {string}
     */
    getClassName(): string {
        return 'FeedbackResponse';
    }

    /**
     * Converts plain (literal) object to class (constructor) object. Also works with arrays.
     */
    static new(plain: [], options?: ClassTransformOptions): FeedbackResponse[];
    static new(plain: {}, options?: ClassTransformOptions): FeedbackResponse;
    static new(plain: {} | [], options?: ClassTransformOptions): FeedbackResponse | FeedbackResponse[] {
        return plainToClass(FeedbackResponse, plain as any, options);
    }
}

export default FeedbackResponse;
